import { render, staticRenderFns } from "./PlanUploadAdmin.vue?vue&type=template&id=e51d7234&scoped=true&"
import script from "./PlanUploadAdmin.vue?vue&type=script&lang=js&"
export * from "./PlanUploadAdmin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e51d7234",
  null
  
)

export default component.exports